import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
var store = null;
var partner = "Volcano";
var channel = "Volcano_web";
var appName = "Volcano_web";
var baseUrl = "https://static.trustdecision.com/tdfp/us/9ae79d76332c99898fa637b16d22e455/fm.js";
var onSuccess = function onSuccess(data) {
  if (store) {
    store.commit('user/setBlackBox', data);
  }
};
export var initTongdun = function initTongdun(opts) {
  var _opts$timeoutMs, _opts$partner, _opts$channel, _opts$appName, _opts$baseUrl;
  console.log('11111111');
  // 延迟获取 store，避免初始化顺序问题
  if (!store) {
    try {
      store = require('@/store').store;
    } catch (e) {
      console.error('Failed to get store:', e);
      return;
    }
  }

  // 如果已经有 blackBox,直接返回,不再重新获

  var EXISTING_ID = "tongdun-fm-script";
  var timeoutMs = (_opts$timeoutMs = opts === null || opts === void 0 ? void 0 : opts.timeoutMs) !== null && _opts$timeoutMs !== void 0 ? _opts$timeoutMs : 10000;
  var p = (_opts$partner = opts === null || opts === void 0 ? void 0 : opts.partner) !== null && _opts$partner !== void 0 ? _opts$partner : partner;
  var c = (_opts$channel = opts === null || opts === void 0 ? void 0 : opts.channel) !== null && _opts$channel !== void 0 ? _opts$channel : channel;
  var a = (_opts$appName = opts === null || opts === void 0 ? void 0 : opts.appName) !== null && _opts$appName !== void 0 ? _opts$appName : appName;
  var url = (_opts$baseUrl = opts === null || opts === void 0 ? void 0 : opts.baseUrl) !== null && _opts$baseUrl !== void 0 ? _opts$baseUrl : baseUrl;

  // 配置 _fmOpt(保留已有 success,并在之后追加)
  window._fmOpt = window._fmOpt || {};
  window._fmOpt.partner = p;
  window._fmOpt.channel = c;
  window._fmOpt.appName = a;
  window._fmOpt.timeout = 10000;
  var prevSuccess = window._fmOpt.success;
  window._fmOpt.success = function (data) {
    try {
      onSuccess === null || onSuccess === void 0 || onSuccess(data);
    } catch (_) {}
    try {
      prevSuccess && prevSuccess(data);
    } catch (_) {}
  };

  // 脚本注入(若不存在)
  var fm = document.getElementById(EXISTING_ID);
  if (!fm) {
    fm = document.createElement("script");
    fm.type = "text/javascript";
    fm.async = true;
    fm.id = EXISTING_ID;
    var hourlyTs = Math.floor(Date.now() / 3600000).toString();
    fm.src = "".concat(url, "?t=").concat(hourlyTs);
    fm.addEventListener("error", function () {
      console.error("tongdun script load error");
    });
    var firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(fm, firstScript);
    } else if (document.head) {
      document.head.appendChild(fm);
    } else {
      document.documentElement.appendChild(fm);
    }
  }
};